import { IInProcessSwap } from "./in-process-swap";

export interface IPolyline {
    path: { lat: number, lng: number }[],
    strokeColor: string,
    strokeOpacity: number,
    strokeWeight: number,
    swap: IInProcessSwap
}